import classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { CorporateBundle, ProcessorBundle } from "components/licenses/bundles";
import style from "components/licenses/license-tier-banner/license-tier-banner.scss";
import PricingTierView from "components/tenants/PricingTierView";
import { LicensingModel, OldLicensingModelTier } from "domain/tenants";
import { generateTierToTranslationMap } from "domain/tierRelatedMaps";
import { getCurrentTenantDetails, getTenantTier, hasTenantCookie } from "services/tenants/tenantCookieService";
import { StoreState } from "store";

interface Props {
    currentProductsInRateCard?: string[];
}

const LicenseTierBanner = (props: Props): JSX.Element => {
    const { t } = useTranslation();
    const tier = hasTenantCookie() ? getTenantTier() : useSelector((state: StoreState) => state.userReducer.user?.tier);
    const tenantDetails = getCurrentTenantDetails();
    const [pricingTierModalVisible, setPricingTierModalVisible] = React.useState(false);
    const basicTiers = [
        OldLicensingModelTier.BASIC,
        CorporateBundle.ESSENTIALS.toString(),
        ProcessorBundle.CORE.toString(),
    ];
    const standardTiers = [
        OldLicensingModelTier.STANDARD,
        CorporateBundle.POWER.toString(),
        ProcessorBundle.PRO.toString(),
    ];
    return (
        <>
            <div
                className={classNames(
                    style.tierContainer,
                    basicTiers.includes(tier || "")
                        ? style.basicBanner
                        : standardTiers.includes(tier || "")
                          ? style.premiumBanner
                          : style.diamondBanner,
                    style.tierBannerAlignment
                )}
            >
                <div className={style.textAndBannerContainer}>
                    <div>
                        {t("Licenses.licenseTierBanner.currentTier")}
                        <strong>
                            {t("Licenses.licenseTierBanner.tierName", {
                                tier: generateTierToTranslationMap(t).get(tier || ""),
                            })}
                        </strong>
                        {t("Licenses.licenseTierBanner.contactPerson", {
                            tierOrBundle:
                                tenantDetails.licensingModel == LicensingModel.OLD_MODEL
                                    ? t("Licenses.licenseTierBanner.tier")
                                    : t("Licenses.licenseTierBanner.bundle"),
                        })}
                    </div>
                </div>
                <button onClick={() => setPricingTierModalVisible(true)}>
                    <strong className={style.viewDetailsAlignment}>{t("Licenses.viewDetails")}</strong>
                </button>
            </div>
            <PricingTierView
                tenantType={tenantDetails.type}
                visibility={pricingTierModalVisible}
                setVisibility={setPricingTierModalVisible}
                selectedTier={tier || ""}
                tenantModal={tenantDetails.licensingModel}
                currentProductsInRateCard={props.currentProductsInRateCard}
            />
        </>
    );
};

export default LicenseTierBanner;
